export default __webpack_public_path__ + "static/media/EasternProvince.ee7f78c0.mp4";